import { pxToRem } from "../../../utills/pxToRem";

export default {
    baseStyle: {
        container: { style: { alignItems: 'baseline' } },
        label: {
            width: 'full',
            color: 'black',
            textTransform: 'uppercase',
            _checked: {
                color: 'cav_calltoaction_darkred'
            }
        },
        control: {
            marginTop: pxToRem(2),
            borderColor: 'black',
            borderWidth: pxToRem(1),
            borderRadius: 0,
            height: pxToRem(12),
            width: pxToRem(12),
            _checked: {
                backgroundColor: 'cav_calltoaction_darkred',
                borderColor: 'cav_calltoaction_darkred',
                color: 'cav_calltoaction_darkred',
                _hover: {
                    bg: 'cav_calltoaction_darkred',
                    borderColor: 'cav_calltoaction_darkred'
                }
            },
            _focusVisible: {
                boxShadow: 'none'
            }
        },
    },
    sizes: {
        md: {
            label: { fontSize: 'sm' }
        }
    }
}
